module.exports = __webpack_public_path__ + "img/CasinoChangeName_6156aadd1476f6ab518c1fca5b92d8b1_20211014005923.5b112da6.jpg";